import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/home/Home";
import About from "./pages/about/About";
import Contact from "./pages/contact/Contact";
import Jobs from "./pages/jobs/Jobs";
import Privacy from "./pages/privacy/Privacy";
import Terms from "./pages/terms/Terms";
import Services from "./pages/services/Services";
import Products from "./pages/products/Products";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/jobs" element={<Jobs />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/services" element={<Services />} />
      <Route path="/products" element={<Products />} />
      <Route path="/services/*" element={<Navigate to="/services" replace />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
};

export default AppRoutes;
